import React, { useRef } from 'react';

import Preview from './Preview';
import StepOne from './StepOne';
import { useWizardState } from '../../contexts/WizardStateContext';

const START = 1;
const FORM = 2;
const FINAL = 3;

const STEP_ROUTES: Record<number, string> = {
  [START]: '/producer/product/newproduct',
  [FINAL]: '/producer/product/newproduct/preview'
};

interface Props {
  children?: React.ReactNode;
}

const Wizard = ({ children }: Props) => {
  const { step } = useWizardState();
  const prevStepRef = useRef(step);

  if (prevStepRef.current !== step) {
    const route = STEP_ROUTES[step];

    if (route) {
      window.history.replaceState(null, null, route);
    }

    prevStepRef.current = step;
  }

  return (
    <>
      {step === START && (
        <div className='animate-fade-in'>
          <StepOne />
        </div>
      )}
      {step === FORM && (
        <div className='animate-fade-in'>
          <div>{children}</div>
        </div>
      )}
      {step === FINAL && <Preview />}
    </>
  );
};

export default Wizard;
